import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import { StyleSheet, View, SafeAreaView, StatusBar } from 'react-native';
import overlay from '../styles/overlay';
import PnmacAppBar, { DEFAULT_APPBAR_HEIGHT } from './PnmacAppBar.js';
import shadow from '../styles/shadow';
import { APPROX_STATUSBAR_HEIGHT } from '../constants';
import color from 'color';
import { primary } from "../styles/colors";
/**
 *
 * ## Usage
 * ```js
 * import * as React from 'react';
 * import { Appbar } from 'pnmac-universal-components';
 *
 * export default class MyComponent extends React.Component {
 *   _goBack = () => console.log('Went back');
 *
 *   _handleSearch = () => console.log('Searching');
 *
 *   _handleMore = () => console.log('Shown more');
 *
 *   render() {
 *     return (
 *       <PnmacAppbar.Header>
 *         <PnmacAppbar.BackAction
 *           onPress={this._goBack}
 *         />
 *         <PnmacAppbar.Content
 *           title="Title"
 *           subtitle="Subtitle"
 *         />
 *         <PnmacAppbar.Action icon="magnify" onPress={this._handleSearch} />
 *         <PnmacAppbar.Action icon="dots-vertical" onPress={this._handleMore} />
 *       </PnmacAppbar.Header>
 *     );
 *   }
 * }
 * ```
 */
var AppbarHeader = /** @class */function (_super) {
  __extends(AppbarHeader, _super);
  function AppbarHeader() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  AppbarHeader.prototype.render = function () {
    var _a = this.props,
      // Don't use default props since we check it to know whether we should use SafeAreaView
      _b = _a.statusBarHeight,
      // Don't use default props since we check it to know whether we should use SafeAreaView
      statusBarHeight = _b === void 0 ? APPROX_STATUSBAR_HEIGHT : _b,
      style = _a.style,
      dark = _a.dark,
      rest = __rest(_a, ["statusBarHeight", "style", "dark"]);
    var _c = StyleSheet.flatten(style) || {},
      _d = _c.height,
      height = _d === void 0 ? DEFAULT_APPBAR_HEIGHT : _d,
      _e = _c.elevation,
      elevation = _e === void 0 ? 4 : _e,
      customBackground = _c.backgroundColor,
      _f = _c.zIndex,
      zIndex = _f === void 0 ? 0 : _f,
      restStyle = __rest(_c, ["height", "elevation", "backgroundColor", "zIndex"]);
    var backgroundColor = customBackground ? customBackground : "#003087";
    // Let the user override the behaviour
    var Wrapper = typeof this.props.statusBarHeight === 'number' ? View : SafeAreaView;
    // StatusBar.setBarStyle('dark-content');
    return /*#__PURE__*/React.createElement(Wrapper, {
      style: [{
        backgroundColor: backgroundColor,
        zIndex: zIndex,
        elevation: elevation
      }, shadow(elevation)]
    }, /*#__PURE__*/React.createElement(PnmacAppBar, __assign({
      style: [{
        height: height,
        backgroundColor: backgroundColor,
        marginTop: statusBarHeight
      }, styles.appbar, restStyle],
      dark: dark
    }, rest)));
  };
  AppbarHeader.displayName = 'Appbar.Header';
  return AppbarHeader;
}(React.Component);
var styles = StyleSheet.create({
  appbar: {
    elevation: 0
  }
});
export default AppbarHeader;
export { AppbarHeader };